import { Link } from "react-router-dom";
import { useMediaQuery } from "@mui/material";
import NotaIcon from "formassets/nota.svg?react";
import Form from "../../components/Form";
import styles from "./styles.module.scss";

const BULLETS = [
  "Szyfrowane po stronie nadawcy",
  "Rozszyfrowywane u adresata",
  "Zero dostępu do treści wiadomości",
  "Zgodność z RODO",
];

function LandingPage() {
  const isMobile = useMediaQuery("(max-width: 1023px)");

  return (
    <div className={styles.root}>
      <div className={styles.frame}>
        <div className={styles.bgl}></div>
        <div className={styles.bgr}></div>

        <div className={styles.scroll}>
          <div className={styles.content}>
            <section className={styles.intro}>
              <h1 className={styles.title}>Wklej, Zaszyfruj, Wyślij</h1>
              <div className={styles.divider}></div>
              <p className={styles.description}>
                Wysyłaj tak, aby Twoje wiadomości mogły być odczytane tylko
                przez te osoby, dla których są przeznaczone
              </p>
              {!isMobile && (
                <>
                  <div className={styles.divider}></div>
                  <ul className={styles.bullets}>
                    {BULLETS.map((text) => (
                      <li key={text} className={styles.bullet}>
                        <span className={styles.dot}></span>
                        <span>{text}</span>
                      </li>
                    ))}
                  </ul>
                </>
              )}
            </section>

            <section className={styles.formColumn}>
              <div className={styles.formCard}>
                <Form
                  id={null}
                  inline={true}
                  settings={{
                    FieldStyle: "standard",
                    ShowHeader: true,
                    HeaderTitle: "Wyślij przesyłkę szyfrowaną",
                    Theme: 0,
                  }}
                />
              </div>
            </section>
          </div>
        </div>

        <footer className={styles.footer}>
          <div className={styles.copyright}>
            eSzyfrowane.pl © 2026 KFJ Inwestycje Sp. z o. o.
          </div>
          <nav className={styles.links}>
            <Link to="/regulamin" className={styles.link}>
              Regulamin
            </Link>
            <Link to="/polityka-prywatnosci" className={styles.link}>
              Polityka prywatności
            </Link>
          </nav>
          <div className={styles.poweredBy}>
            <span>Powered by</span>
            <NotaIcon className={styles.notaLogo} />
          </div>
        </footer>
      </div>
    </div>
  );
}

export default LandingPage;
